import React from 'react'
import PropTypes from 'prop-types'
import { Switch } from 'react-router-dom'
import PrivateRoute from '@components/PrivateRoute'
import application from '@config/application'
import NotFound from '@containers/Pages/NotFound'
import DashboardLayout from '@containers/Layout/Affiliate/DashboardLayout'
import DashboardAffiliate from '@containers/Pages/Admin/Affiliate/Dashboard'

const basePath = `${application.prefix}/affiliate`

const AffiliateRoutes = ({ history }) => (
  <DashboardLayout history={history}>
    <Switch>
      <PrivateRoute path={`${basePath}/dashboard`} component={DashboardAffiliate} />
      <PrivateRoute component={NotFound} />
    </Switch>
  </DashboardLayout>
)

AffiliateRoutes.propTypes = {
  history: PropTypes.any.isRequired,
}

export default AffiliateRoutes
